import { rtkQueryApi } from './rtk-query-api';

interface ApiKeyResponse {
  id: number;
  api_supplier_name: string;
  api_supplier_inn: string;
  updated_at: number;
  created_at: number;
}

interface ApiKey {
  id: number;
  name: string;
  inn: string;
}

interface CheckUserApiKeyResponse {
  id: number;
  error: string | false;
  success: boolean;
}

export const apiKeysApi = rtkQueryApi.injectEndpoints({
  endpoints: (builder) => ({
    getUserApiKeys: builder.query<ApiKey[], void>({
      query: () => ({
        url: '/user/get-user-api',
        method: 'GET',
      }),
      transformResponse: (response: ApiKeyResponse[]): ApiKey[] =>
        response.map(({ id, api_supplier_name, api_supplier_inn, created_at, updated_at }) => ({
          id,
          name: api_supplier_name,
          inn: api_supplier_inn,
          created_at,
          updated_at,
        })),
    }),
    checkUserApiKeys: builder.mutation<CheckUserApiKeyResponse[], { art: string }>({
      query: ({ art }) => ({
        url: `/user/is-active-wb-keys?art=${art}`,
        method: 'POST',
      }),
      transformResponse: (response: CheckUserApiKeyResponse[]) =>
        response.map((item) => ({
          id: item.id,
          success: item.success,
          error: item.success ? false : item.error,
        })),
    }),
    editUserApiKey: builder.mutation<{ success: boolean }, { id: number; key: string }>({
      query: ({ id, key }) => ({
        url: `/user/update-api?id=${id}`,
        method: 'POST',
        body: { key },
      }),
    }),
    deleteUserApiKey: builder.mutation<{ success: boolean }, { id: number }>({
      query: ({ id }) => ({
        url: `/user/delete-api?id=${id}`,
        method: 'POST',
      }),
    }),
    addUserApiKey: builder.mutation<{ success: boolean }, { art: string; key: string }>({
      query: ({ art, key }) => ({
        url: `/user/add-api?art=${art}`,
        method: 'POST',
        body: { key },
      }),
    }),
  }),
});

export const {
  useGetUserApiKeysQuery,
  useLazyGetUserApiKeysQuery,
  useEditUserApiKeyMutation,
  useDeleteUserApiKeyMutation,
  useAddUserApiKeyMutation,
  useCheckUserApiKeysMutation,
} = apiKeysApi;
